import { render, staticRenderFns } from "./UploadConclusionReport.vue?vue&type=template&id=2a301e4a"
import script from "./UploadConclusionReport.vue?vue&type=script&lang=js"
export * from "./UploadConclusionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports